import { create } from 'zustand';
import { ImportJob } from '@domain/connection/models/ImportJob';

interface ImportJobsState {
  jobs: ImportJob[];
  addJob: (job: Omit<ImportJob, 'startedAt'> & { startedAt?: number }) => void;
  removeJob: (id: string) => void;
}

export const useImportJobsStore = create<ImportJobsState>()((set) => ({
  jobs: [],
  addJob: (job) =>
    set((state) => ({
      jobs: [...state.jobs.filter((j) => j.id !== job.id), { ...job, startedAt: job.startedAt ?? Date.now() }],
    })),
  removeJob: (id) =>
    set((state) => ({
      jobs: state.jobs.filter((j) => j.id !== id),
    })),
}));
